import pkgJson from '../../../../package.json';

export const environment = {
  production: true,

  app_version: pkgJson.version
};
